import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import React from "react";
import { useIntl } from "react-intl";
import { Nav, NavbarBrand, Media } from "reactstrap";
import logo from "../../../assets/wembii-logo.png";
import logoWhite from "../../../assets/wembii-logo-white.png";
import { useBreakpointBelowLg } from "../../../hooks/useBreakpointBelowLg";
import { useGlobalCore } from "../../../cores/globals";

import SidebarProtectorRoutes from "./SidebarProtectorRoutes";

const SidebarNavigation = () => {
  const intl = useIntl();
  const { setOpenSideBar, isDarkMode, collapseSideBar, setCollapseSideBar } =
    useGlobalCore();
  const isMobileSidebar = useBreakpointBelowLg();
  const narrowDesktopToolbar = collapseSideBar && !isMobileSidebar;

  const toggleCollapse = () => {
    if (!isMobileSidebar) setCollapseSideBar(!collapseSideBar);
  };

  const collapseToggle = !isMobileSidebar ? (
    <button
      type="button"
      className="sidebar-collapse-toggle"
      onClick={toggleCollapse}
      aria-expanded={!collapseSideBar}
      aria-label={
        collapseSideBar
          ? intl.formatMessage({ id: "app.sidebar.expandMenu" })
          : intl.formatMessage({ id: "app.sidebar.collapseMenu" })
      }
    >
      <FontAwesomeIcon
        icon={collapseSideBar ? faChevronRight : faChevronLeft}
        className="sidebar-collapse-toggle-icon"
        aria-hidden
      />
    </button>
  ) : null;

  const brand = (
    <NavbarBrand
      href="/social"
      className={cn(
        "m-0 d-flex sidebar-brand-logo min-w-0",
        isMobileSidebar && "justify-content-center w-100",
        !isMobileSidebar &&
          narrowDesktopToolbar &&
          "justify-content-center w-100",
        !isMobileSidebar &&
          !narrowDesktopToolbar &&
          "flex-grow-1 justify-content-start"
      )}
      onClick={() => {
        if (isMobileSidebar) setOpenSideBar(false);
      }}
    >
      <Media
        className="sidebar-logo-img"
        object
        src={isDarkMode ? logoWhite : logo}
        alt="Wembii"
      />
    </NavbarBrand>
  );

  return (
    <Nav vertical>
      <div
        className={cn("sidebar-brand-toolbar w-100", {
          "sidebar-brand-toolbar--narrow": narrowDesktopToolbar,
        })}
      >
        {narrowDesktopToolbar ? (
          <>
            {collapseToggle}
            {brand}
          </>
        ) : (
          <>
            {brand}
            {collapseToggle}
          </>
        )}
      </div>
      <hr className="horizontal-separator my-2" />
      <SidebarProtectorRoutes />
    </Nav>
  );
};

export default SidebarNavigation;
